import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    ranking: [],
    dates: [],
    loading: false,
    token: null
  },
  mutations: {
    updateRanking (state, ranking) {
      state.ranking = ranking
      state.loading = false
    },
    updateDates (state, dates) {
      state.dates = dates
      state.loading = false
    },
    loading (state) {
      state.loading = true
    }
  },
  actions: {
    loadDates ({ commit }) {
      commit('loading')
      axios.get(
        process.env.VUE_APP_BACKEND_LOCATION + '/song_rankings/dates',
        {
          headers: { Accept: 'application/json' }
        }
      )
        .then(response => {
          commit('updateDates', response.status === 200 ? response.data : [])
        })
    },
    loadRanking ({ commit }, { start, end }) {
      commit('loading')
      axios.get(
        process.env.VUE_APP_BACKEND_LOCATION + '/song_rankings/top',
        {
          headers: { Accept: 'application/json' },
          params: { start, end }
        }
      )
        .then(response => {
          commit('updateRanking', response.status === 200 ? response.data : [])
        })
    }
  },
  getters: {
    rankingCount: (state) => {
      return state.ranking.length
    },
    datesCount: (state) => {
      return state.dates.length
    },
    firstDate: (state) => {
      if (state.dates.length === 0) {
        return new Date()
      }
      return new Date(state.dates.reduce((previous, current) => new Date(current.date) < new Date(previous.date) ? current : previous).date)
    },
    lastDate: (state) => {
      if (state.dates.length === 0) {
        return new Date()
      }
      return new Date(state.dates.reduce((previous, current) => new Date(current.date) > new Date(previous.date) ? current : previous).date)
    },
    allDatesString: (state) => {
      const allDate = []
      state.dates.forEach(item => {
        if (!allDate.includes(item.date)) {
          allDate.push(item.date.substring(0, 10))
        }
      })
      return allDate
    }
  }
})
